import colorVars from "@/assets/styles/colorVars"
import { CustomBackground, blurProps } from "@/components/bg/blur-bg"
import React, { FC } from "react"
import { up } from "styled-breakpoints"
import styled from "styled-components"

import { IBenefit } from "../benefit"
import {
  Benefit,
  StyledHeading as BenefitHeading,
  Description,
  ImageWrapper,
} from "./single"

export interface IBenefits {
  anchor?: string
  benefitsList?: Array<IBenefit>
}

export interface BenefitsProps {
  className?: string
  data?: IBenefits
}

const Wrapper = styled.div<BenefitsProps>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 49px 0;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0 16px;
  margin: 0 auto;

  ${up("md")} {
    gap: 120px;
  }

  ${up("lg")} {
    gap: 160px;
    max-width: calc(1120px + 32px);
  }
`

const StyledBenefit = styled(Benefit)``

const StyledCustomBackground = styled(CustomBackground)`
  display: none;

  ${up("md")} {
    display: block;
  }
`

const BenefitContainer = styled.div`
  &:nth-child(2) {
    ${BenefitHeading} {
      br {
        display: none;
      }
    }
  }

  &:nth-child(3) {
    margin-top: 30px;
  }

  &:nth-child(4) {
    margin-top: 30px;
  }

  &:nth-child(5) {
    margin-top: 32px;
  }

  &:nth-child(6) {
    margin-top: 31px;
  }

  ${up("md")} {
    position: relative;
    width: 100%;
    margin-top: 0 !important;

    ${BenefitHeading} {
      white-space: pre-line !important;
    }

    ${ImageWrapper} {
      position: relative;
    }

    &:nth-child(1) {
      ${ImageWrapper} {
        top: 7px;
      }
    }

    &:nth-child(2) {
      ${BenefitHeading} {
        br {
          display: block;
        }
      }
      ${ImageWrapper} {
        top: 7px;
      }
    }

    &:nth-child(3) {
      ${ImageWrapper} {
        top: 7px;
      }
    }

    &:nth-child(4) {
      ${ImageWrapper} {
        top: 7px;
      }
    }

    &:nth-child(5) {
      ${ImageWrapper} {
        top: 8px;
      }
      ${Description} {
        letter-spacing: 0;
      }
    }

    &:nth-child(6) {
      ${ImageWrapper} {
        top: 7px;
      }
    }
  }
`

const benefitBlurList: Array<Array<blurProps>> = [
  [
    {
      blur: "150px",
      color: colorVars.pink.main,
      opacity: 0.4,
      pos: {
        bottom: "initial",
        left: "0%",
        right: "initial",
        top: "82%",
      },
      size: "120px",
    },
  ],
  [
    {
      blur: "150px",
      color: colorVars.teal.main,
      opacity: 0.4,
      pos: {
        bottom: "initial",
        left: "initial",
        right: "0%",
        top: "26%",
      },
      size: "120px",
    },
  ],
  [
    {
      blur: "150px",
      color: colorVars.blue.main,
      opacity: 0.4,
      pos: {
        bottom: "initial",
        left: "0%",
        right: "initial",
        top: "44%",
      },
      size: "120px",
    },
  ],
  [
    {
      blur: "150px",
      color: colorVars.orange.main,
      opacity: 0.4,
      pos: {
        bottom: "initial",
        left: "initial",
        right: "0%",
        top: "62%",
      },
      size: "120px",
    },
  ],
  [
    {
      blur: "150px",
      color: colorVars.yellow.main,
      opacity: 0.4,
      pos: {
        bottom: "initial",
        left: "0%",
        right: "initial",
        top: "82%",
      },
      size: "120px",
    },
  ],
  [
    {
      blur: "150px",
      color: colorVars.violet.main,
      opacity: 0.4,
      pos: {
        bottom: "initial",
        left: "initial",
        right: "0%",
        top: "102%",
      },
      size: "120px",
    },
  ],
]

export const Benefits: FC<BenefitsProps> = (props) => {
  const { className, data } = props

  if (!data) return null

  const { anchor, benefitsList } = data

  return (
    <Wrapper
      className={className && className !== "" ? className : ""}
      id={anchor ?? "benefits"}>
      {benefitsList?.map((benefit: any, index: number) => {
        return (
          <BenefitContainer key={`benefit-${index}`}>
            <StyledBenefit data={benefit} leftImg={index % 2 ? true : false} />
            <StyledCustomBackground blurs={benefitBlurList[index] ?? 0} />
          </BenefitContainer>
        )
      })}
    </Wrapper>
  )
}
